import { DatePipe, SlicePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { SkeletonImageComponent } from "../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-noticia-listado",
  templateUrl: "./noticia-listado.component.html",
  styleUrls: ["./noticia-listado.component.css"],
  imports: [RouterLink, SlicePipe, DatePipe, KebabCasePipe, SkeletonImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticiaListadoComponent {
  @Input() noticia;
  @Input() txtBusqueda;
  @Input() idStart: number;

  formatDate(obj) {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }
}
